import { trpc } from "@/common/helpers/trpc";

const TWO_HOURS_MS = 2 * 60 * 60 * 1000;

export const useDashboardClickAutocaptureFlag = (enabled: boolean) => {
  const { data } = trpc.getIsDashboardClickAutocaptureEnabled.useQuery(undefined, {
    enabled,
    refetchInterval: TWO_HOURS_MS,
    // The interval pauses in background tabs otherwise, and refetchOnWindowFocus is off globally.
    refetchIntervalInBackground: true,
  });

  return { isActive: Boolean(data) };
};
